<script>
import {getCouponLists, sendCoupon} from "../../api/app";

export default {
  name:'CouponList',
  computed: {
    scope() {
      return scope
    }
  },
  props:{
    users:{
      type:Array,
      default:[]
    },
    chat_type:{
      type:String,
      default:'private'
    },
    thread_id:{
      type:[String,Number],
      default:null
    },
    to_id:{
      type:[String,Number],
      default:null
    }
  },
  data(){
    return {
      lists:[],
      couponShow:true,
      selectUsers:false,
      pagination:{
        page_no:1,
        page_size:10,
        count:0
      },
      coupon_id:null,
      user_id:null,
    }
  },
  async mounted() {
    //获取客服发放优惠券
    await this.getCouponLists();
  },
  methods:{
    selectCouponUser(index,row){
        this.coupon_id = row.id;
      if(this.chat_type=='group'){
        this.selectUsers = true;
      }else{
          this.sendCoupon(0,{user_id:this.to_id});
      }
    },
    async sendCoupon(index,row){
          const res = await sendCoupon({coupon_id:this.coupon_id,user_id:row.user_id,chat_type:this.chat_type,to_id:this.to_id});
          if(res['success']){
            this.$emit('close');
          }
    },
    async getCouponLists(){
      const res = await getCouponLists({
        url:`?page_no=${this.pagination.page_no}&page_size=${this.pagination.page_size}`,
        data:{
          coupon_send_type:1
        }
      });
      this.lists = res.lists;
      this.pagination.count = res.count;
      this.pagination.page_no = res.page_no;
      this.pagination.page_size = res.page_size;
    },
    closeWindow(){
      this.$emit('close');
      this.couponShow = false;
    }
  },
  filters:{
    UserRole(val){
      let user_roles = {1:"买家",2:"卖家",3:"官方客服"};
      return user_roles[val];
    },
    CouponType(val){
        let coupon_types = {1:"无门槛",0:"满减"}
        return coupon_types[val];
    },
    DiscountType(val){
        let discount_types = {1:"折扣",0:"金额"}
        return discount_types[val];
    }
  },
}
</script>

<template>
  <el-dialog title="发放优惠券" width="60vw" top="20vh" :visible="couponShow" @close="closeWindow">
    <el-table :data="lists" border height="300" style="width: 100%">
        <el-table-column prop="id" label="ID" width="100"></el-table-column>
        <el-table-column prop="coupon_name" label="优惠券名称" width="180"></el-table-column>
        <el-table-column prop="coupon_type" label="优惠券类型" width="180">
          <template slot-scope="scope">
            {{scope.row.coupon_type | CouponType}}
          </template>
        </el-table-column>
        <el-table-column prop="discount_type" label="抵扣类型" width="180">
          <template slot-scope="scope">
            {{scope.row.discount_type | DiscountType}}
          </template>
        </el-table-column>
        <el-table-column prop="discount_value" label="金额/折扣" width="180"></el-table-column>
        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-button
                size="mini"
                @click="selectCouponUser(scope.$index, scope.row)">{{ chat_type=='group'?'选择用户':'发放优惠券'}}
            </el-button>
          </template>
        </el-table-column>
    </el-table>
    <el-pagination
        @current-change=""
        :current-page="pagination.page_no"
        :page-sizes="[1,5, 10, 20, 50]"
        :page-size="pagination.page_size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.count">
    </el-pagination>


    <el-dialog
        width="32vw"
        title="选择用户"
        :visible.sync="selectUsers"
        append-to-body
    >
      <el-table :data="users" border style="width: 100%;">
        <el-table-column prop="user_id" label="用户ID" width="100"></el-table-column>
        <el-table-column prop="avatar" label="用户头像"  align="center" width="80">
          <template slot-scope="scope" >
           <el-avatar :src="'https://img.taohaozhijia.cn/'+scope.row.avatar" ></el-avatar>
          </template>
        </el-table-column>
        <el-table-column prop="nickname" label="用户昵称" width="160"></el-table-column>
        <el-table-column prop="user_id" label="用户角色" width="100">
          <template slot-scope="scope">
           {{ scope.row.user_role | UserRole }}
          </template>
        </el-table-column>
        <el-table-column align="left" label="操作">
          <template slot-scope="scope">
            <el-button
                size="mini"
                @click="sendCoupon(scope.$index, scope.row)">发放优惠券
            </el-button>
          </template>
        </el-table-column>
      </el-table>

    </el-dialog>

  </el-dialog>


</template>

<style scoped lang="scss">

</style>